import { postMessageToNative } from "~/lib/webview";
import { getAdjustToken } from "./adjustTokens";
import { getCurrentAdjustPlatform, isNativeApplication } from "./platform";

export type AdjustParams = {
  callback?: Record<string, string>;
  partner?: Record<string, string>;
};

const toKeyValues = (params?: Record<string, string>) =>
  Object.entries(params ?? {}).map(([key, value]) => ({ key, value }));

export type AdjustRevenue = {
  revenue: number;
  currency: string;
};

/**
 * Adjust イベントを送信する（ネイティブアプリのみ）。
 *
 * - isNativeApplication() が false の場合は何もしない
 * - ADJUST_TOKENS にトークンが定義されていないイベント・プラットフォームは送信しない
 * - revenue を渡すと収益イベントとして送信する（例: Corun の purchased イベント）
 * - params は Native が受理する `[{key, value}]` 配列に変換して送る（未指定は空配列）
 */
export const trackAdjustEvent = (
  eventName: string,
  revenue?: AdjustRevenue,
  params?: AdjustParams,
): void => {
  // 直後に WebView が破棄される経路で落ちないよう同期で送る
  try {
    if (!isNativeApplication()) return;

    const platform = getCurrentAdjustPlatform();
    if (!platform) return;

    const eventToken = getAdjustToken(eventName, platform);
    if (!eventToken) return;

    postMessageToNative({
      type: "ADJUST_TRACK_EVENT",
      payload: {
        eventToken,
        callbackParams: toKeyValues(params?.callback),
        partnerParams: toKeyValues(params?.partner),
        ...(revenue
          ? { revenue: revenue.revenue, currency: revenue.currency }
          : {}),
      },
    });
  } catch {
    // 補助機能のため例外は握りつぶす
  }
};
